module.exports = __webpack_public_path__ + "static/Arthur-Pelberg-690108d81f7e711e1811088f9ae3ad6c.png";